import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/DemurrageAndDetention/components/SectionImpact/SectionImpact.module.scss';

const cn = classNames.bind(styles);

const SectionImpact = (): ReactElement => {


  return (
    <section className={cn('impact')}>
      <div className={cn('container')}>

        <h2 className={cn('impact__heading')}>
          Impact on Stakeholders
        </h2>

        <div className={cn('impact__paragraphs')}>
          <p className={cn('impact__paragraph')}>
            The final OSRA 22 rule in 2024 offers greater protection against dishonest 
            charges and ensures more transparent invoices, providing Beneficial Cargo 
            Owners (BCOs) with accurate invoices on time. The smoother billing processes 
            result from clearer accountability and fewer disputes, leading to quicker 
            and more precise billing cycles.
          </p>
          <p className={cn('impact__paragraph')}>
            This efficiency allows logistics companies to focus on providing reliable 
            services instead of dealing with billing disagreements. Multimodal Transport 
            Operators (MTOs) must adhere to the same invoicing regulations as carriers 
            to maintain a uniform billing procedure internationally.
          </p>
        </div>

      </div>
    </section>
  );
};

export default SectionImpact;